// Generic size definitions reused by photos and covers.
const SIZE_SPECS = [
    { key: 'thumbnail', dirSuffix: 'thumbnails', maxDimension: 600,  quality: 0.82 },
    { key: 'medium',    dirSuffix: 'medium',     maxDimension: 2000, quality: 0.82 },
];

export const VARIANT_CONTENT_TYPE = 'image/jpeg';

const buildVariants = (baseDir, fieldPrefix) =>
    SIZE_SPECS.map((s) => ({
        ...s,
        dir: `${baseDir}/${s.dirSuffix}`,
        field: fieldPrefix
            ? `${fieldPrefix}${s.key.charAt(0).toUpperCase() + s.key.slice(1)}Path`
            : `${s.key}Path`,
    }));

export const PHOTO_VARIANTS = buildVariants('photos', '');
export const CATEGORY_COVER_VARIANTS = buildVariants('category-covers', 'cover');
export const GALLERY_COVER_VARIANTS = buildVariants('gallery-covers', 'cover');

// Each backfill target points at a Firestore collection plus the variant set
// to generate for documents in that collection.
export const BACKFILL_TARGETS = [
    { collection: 'photos',     pathField: 'path',      variants: PHOTO_VARIANTS },
    { collection: 'categories', pathField: 'coverPath', variants: CATEGORY_COVER_VARIANTS },
    { collection: 'galleries',  pathField: 'coverPath', variants: GALLERY_COVER_VARIANTS },
];

export const buildVariantPath = (variant, id) => `${variant.dir}/${id}.jpg`;

export async function generateVariantBlob(source, variant) {
    const bitmap = await loadBitmap(source);
    const { width, height } = scaleDown(bitmap.width, bitmap.height, variant.maxDimension);

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(bitmap, 0, 0, width, height);

    const blob = await new Promise((resolve, reject) => {
        canvas.toBlob(
            (b) => (b ? resolve(b) : reject(new Error(`Failed to encode ${variant.key} variant`))),
            VARIANT_CONTENT_TYPE,
            variant.quality,
        );
    });

    if (typeof bitmap.close === 'function') bitmap.close();
    return blob;
}

async function loadBitmap(source) {
    if (typeof createImageBitmap === 'function') {
        try {
            return await createImageBitmap(source);
        } catch (e) {
            // Fall back to <img> below.
        }
    }

    const url = URL.createObjectURL(source);
    try {
        return await new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = () => resolve(img);
            img.onerror = () => reject(new Error('Failed to decode image'));
            img.src = url;
        });
    } finally {
        URL.revokeObjectURL(url);
    }
}

function scaleDown(width, height, max) {
    if (width <= max && height <= max) return { width, height };
    const ratio = width >= height ? max / width : max / height;
    return { width: Math.round(width * ratio), height: Math.round(height * ratio) };
}
